const GoodsReceiptCreationScreenStyles = {
  splitWrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    overflow: 'hidden',
    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
  },

  formPanel: {
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    p: { xs: 2, md: 4 },
    minWidth: 0,
    transition: 'flex 0.3s ease',
    flexShrink: 0
  },

  viewerPanel: {
    flex: '0 0 44%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    background: '#ffffff',
    borderRight: '2px solid #e2e8f0',
    boxShadow: '2px 0 16px rgba(0,0,0,0.08)',
    flexShrink: 0
  },

  viewerPanelHeader: {
    px: 2.5,
    py: 1.75,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '2px solid #e2e8f0',
    background: 'linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)',
    flexShrink: 0
  },

  viewerPanelContent: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },

  header: {
    mb: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 2
  },

  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 2
  },

  backButton: {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    color: '#64748b',
    borderColor: '#cbd5e1',
    px: 2.5,
    py: 1,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      borderColor: '#94a3b8',
      backgroundColor: '#f1f5f9',
      transform: 'translateX(4px)'
    }
  },

  titleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 2
  },

  titleIcon: {
    width: 48,
    height: 48,
    borderRadius: '14px',
    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
    '& svg': {
      fontSize: '1.5rem',
      color: '#fff'
    }
  },

  title: {
    fontWeight: 800,
    fontSize: '1.75rem',
    background: 'linear-gradient(135deg, #1e293b 0%, #475569 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    letterSpacing: '-0.02em'
  },

  subtitle: {
    color: '#64748b',
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: 1
  },

  orderBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    px: 1.5,
    py: 0.5,
    borderRadius: '8px',
    backgroundColor: '#e0e7ff',
    color: '#4338ca',
    fontWeight: 600,
    fontSize: '0.813rem'
  },

  infoCard: {
    p: 3,
    mb: 3,
    borderRadius: '20px',
    border: 'none',
    background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      width: '100%',
      height: '4px',
      background: 'linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899)',
      backgroundSize: '200% 100%',
      animation: 'gradient 4s ease infinite'
    },
    '@keyframes gradient': {
      '0%, 100%': { backgroundPosition: '0% 50%' },
      '50%': { backgroundPosition: '100% 50%' }
    }
  },

  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: 3
  },

  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    p: 2,
    borderRadius: '12px',
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#cbd5e1',
      backgroundColor: '#f1f5f9'
    }
  },

  infoLabel: {
    fontWeight: 600,
    color: '#64748b',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em'
  },

  infoValue: {
    fontWeight: 700,
    color: '#1e293b',
    fontSize: '1rem'
  },

  tableCard: {
    borderRadius: '20px',
    border: 'none',
    background: '#ffffff',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08)'
  },

  tableHeader: {
    p: 2.5,
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    borderBottom: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  tableTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    color: '#1e293b',
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    '& svg': {
      color: '#3b82f6'
    }
  },

  tableHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 2
  },

  rowCount: {
    color: '#64748b',
    fontSize: '0.875rem',
    fontWeight: 500,
    px: 2,
    py: 0.75,
    borderRadius: '10px',
    backgroundColor: '#f1f5f9'
  },

  tableContainer: {
    maxHeight: '450px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f5f9'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#cbd5e1',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: '#94a3b8'
      }
    }
  },

  table: {
    minWidth: 800
  },

  tableHeaderCell: {
    backgroundColor: '#f8fafc',
    fontWeight: 700,
    color: '#475569',
    fontSize: '0.813rem',
    textTransform: 'none',
    py: 2,
    whiteSpace: 'nowrap',
    borderBottom: '2px solid #e2e8f0',
    letterSpacing: '0.02em'
  },

  tableRow: {
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f8fafc'
    },
    '&.deleted': {
      backgroundColor: '#fef2f2',
      '& td': {
        textDecoration: 'line-through',
        color: '#94a3b8',
        opacity: 0.7
      }
    }
  },

  tableCell: {
    py: 2,
    fontSize: '0.875rem',
    color: '#334155',
    borderBottom: '1px solid #e2e8f0',
    fontWeight: 500
  },

  editableCell: {
    py: 1,
    px: 1.5
  },

  editInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      backgroundColor: '#fff',
      fontSize: '0.875rem',
      fontWeight: 500,
      transition: 'all 0.2s ease',
      '& fieldset': {
        borderColor: '#e2e8f0',
        borderWidth: '2px'
      },
      '&:hover fieldset': {
        borderColor: '#94a3b8'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3b82f6',
        borderWidth: '2px',
        boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)'
      }
    },
    '& .MuiOutlinedInput-input': {
      py: 1.25,
      px: 1.5,
      textAlign: 'center'
    }
  },

  selectInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      backgroundColor: '#fff',
      fontSize: '0.875rem',
      '& fieldset': {
        borderColor: '#e2e8f0',
        borderWidth: '2px'
      },
      '&:hover fieldset': {
        borderColor: '#94a3b8'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3b82f6',
        borderWidth: '2px'
      }
    }
  },

  deleteRowButton: {
    color: '#ef4444',
    borderRadius: '10px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#fef2f2',
      transform: 'scale(1.1)'
    }
  },

  restoreRowButton: {
    color: '#22c55e',
    borderRadius: '10px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f0fdf4',
      transform: 'scale(1.1)'
    }
  },

  actionsContainer: {
    p: 3,
    mt: 3,
    borderRadius: '20px',
    background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 3,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08)'
  },

  summaryBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 4
  },

  summaryItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5
  },

  summaryLabel: {
    color: '#64748b',
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },

  summaryValue: {
    fontWeight: 800,
    color: '#1e293b',
    fontSize: '1.5rem'
  },

  actionsButtons: {
    display: 'flex',
    gap: 2
  },

  cancelButton: {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1.25,
    borderColor: '#cbd5e1',
    borderWidth: '2px',
    color: '#64748b',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      borderColor: '#94a3b8',
      backgroundColor: '#f1f5f9',
      borderWidth: '2px'
    }
  },

  saveDraftButton: {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 700,
    px: 4,
    py: 1.25,
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    color: '#fff',
    boxShadow: '0 4px 14px rgba(34, 197, 94, 0.4)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
      boxShadow: '0 6px 20px rgba(34, 197, 94, 0.5)',
      transform: 'translateY(-2px)'
    },
    '&.Mui-disabled': {
      background: '#e2e8f0',
      boxShadow: 'none',
      color: '#94a3b8'
    }
  },

  finalizeButton: {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 700,
    px: 4,
    py: 1.25,
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    color: '#fff',
    boxShadow: '0 4px 14px rgba(34, 197, 94, 0.4)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
      boxShadow: '0 6px 20px rgba(34, 197, 94, 0.5)',
      transform: 'translateY(-2px)'
    },
    '&.Mui-disabled': {
      background: '#e2e8f0',
      boxShadow: 'none',
      color: '#94a3b8'
    }
  },

  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    borderRadius: '20px'
  },

  loadingContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2.5
  },

  loadingText: {
    color: '#475569',
    fontWeight: 600,
    fontSize: '1rem'
  },

  errorAlert: {
    mb: 3,
    borderRadius: '16px',
    border: '2px solid #f87171',
    background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
    boxShadow: '0 4px 14px rgba(239, 68, 68, 0.15)',
    '& .MuiAlert-icon': {
      color: '#ef4444'
    }
  },

  successAlert: {
    mb: 3,
    borderRadius: '16px',
    border: '2px solid #4ade80',
    background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
    boxShadow: '0 4px 14px rgba(34, 197, 94, 0.15)',
    '& .MuiAlert-icon': {
      color: '#22c55e'
    }
  },

  emptyState: {
    p: 6,
    textAlign: 'center'
  },

  emptyIcon: {
    fontSize: '4rem',
    color: '#cbd5e1',
    mb: 2
  },

  emptyText: {
    fontSize: '1.125rem',
    fontWeight: 600,
    color: '#64748b'
  },

  createdDocInfo: {
    p: 3,
    borderRadius: '16px',
    background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
    border: '2px solid #34d399',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    mb: 3
  },

  createdDocText: {
    fontWeight: 700,
    color: '#065f46',
    fontSize: '1.125rem'
  },

  warehouseInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      backgroundColor: '#fff',
      fontWeight: 500,
      '& fieldset': {
        borderColor: '#e2e8f0',
        borderWidth: '2px'
      },
      '&:hover fieldset': {
        borderColor: '#94a3b8'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3b82f6',
        borderWidth: '2px'
      }
    }
  },

  viewInvoiceButton: {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    px: 2.5,
    py: 1,
    borderColor: '#3b82f6',
    borderWidth: '2px',
    color: '#3b82f6',
    backgroundColor: '#eff6ff',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      borderColor: '#1d4ed8',
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
      borderWidth: '2px',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)'
    }
  },

  hideInvoiceButton: {
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    px: 2.5,
    py: 1,
    borderColor: '#94a3b8',
    borderWidth: '2px',
    color: '#64748b',
    backgroundColor: '#f8fafc',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      borderColor: '#64748b',
      backgroundColor: '#f1f5f9',
      borderWidth: '2px'
    }
  }
};

export default GoodsReceiptCreationScreenStyles;
